/* eslint-disable guard-for-in */
<template>
  <div class="rule-based app-page">
    <vue-headful title="ALICE | Config File"></vue-headful>
    <div class="column-wrapper">
      <!-- COLUMN LEFT -->
      <div class="single-column-left white-bg">
        <div class="column-content full-height">
          <label class="label title-label">Config File</label>
          <div class="field is-grouped no-shrink">
            <div class="control is-expanded">
              <div class="field has-addons">
                <div class="control">
                  <button class="button is-static is-small">
                    <span class="icon">
                      <font-awesome-icon icon="folder"></font-awesome-icon>
                    </span>
                    <span>Config File</span>
                  </button>
                </div>

                <div class="control is-expanded">
                  <div class="select is-small is-fullwidth">
                    <select v-model="selectedConfigFileIdValue" @change="reloadConfigFile(selectedConfigFileId, $event)" :disabled="!allConfigFile.length">
                      <option v-for="config in allConfigFile" :key="config.id" :value="config.id">
                        {{ config.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="control">
               <button class="button is-small is-info"
                @click="createNewConfig">
                <span class="icon">
                  <font-awesome-icon icon="plus"></font-awesome-icon>
                </span>
                <span>Create new config</span>
              </button>
            </div>
          </div>
          <div class="field no-margin">
          </div>
          <!-- Button:: Add new config -->
          <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="false"></b-loading>
          <div v-if="allConfigFile.length === 0 && dataList.length === 0 && !isLoading" class="flex-section flex-bg justify-content-center">
            <div class="align-self-center" style="text-align: center">
              <span class="fas fa-info-circle" style="font-size: 2rem;"></span><br>
              <span>No data</span><br>
              <span>Click <b>+Create new config</b> button to create a new config</span>
            </div>
          </div>
          <!-- Display Data List -->
          <div v-if="dataList.length > 0" class="flex-section flex-bg">
            <div class="list-wrapper">
              <virtual-list :size="42" :remain="25" :bench="50" :debounce="200" ref="ruleList">
                <div
                  v-for="(rule, index) in sortedRuleList"
                  @click="toggleRule(rule.path)"
                  class="rule-level"
                  :key="rule.id+'-'+index"
                  :style="styleObject(rule)"
                >
                  <div class="rule-inner" :class="{'selected-rule': rule.path === selectedRuleId }">
                    <span>
                      <span class="level-icon" v-if="rule.level > 0">↳ </span>
                      <span> <i :class="getIcon(rule)" class="mr-1"></i> </span>
                      <span :class="getTextColor(rule)">  {{ rule.name }}</span>
                    </span>
                    <div class="is-pulled-right">
                      <div class="field is-grouped">
                        <div class="control" v-if="rule.level > 0">
                          <button
                            class="button is-danger is-inverted is-small"
                            @click="removeSubRule(rule)"
                          >
                            <span class="icon">
                              <font-awesome-icon icon="trash"></font-awesome-icon>
                            </span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </virtual-list>

            </div>
          </div>
          <!-- Delete config file -->
          <div class="field bottom-field">
            <div class="control">
              <button class="button is-danger is-inverted is-small"
              :disabled="!selectedConfigFileId"
                @click="deleteConfigFileById(selectedConfigFileId)"
              >
                <span class="icon">
                  <font-awesome-icon icon="trash"></font-awesome-icon>
                </span>
                <span>Delete config file</span>
              </button>
            </div>
            <div class="rule-set-id">Config file id: {{ selectedConfigFileId }}</div>
          </div>
        </div>
      </div>
      <!-- COLUMN RIGHT -->
      <div class="single-column-right white-bg">
        <div class="column-content full-height">
          <template v-if="selectedRuleId">
            <section class="head-toolbar">
              <div class="toolbar">
                <div class="toolbar-wrapper">
                </div>
                <button class="button is-success has-badge-rounded has-badge-danger"
                    v-if="ruleDirty"
                    @click="saveConfig"
                    data-badge
                >
                  <span class="icon">
                    <font-awesome-icon icon="save"></font-awesome-icon>
                  </span>
                  <span>Save</span>
                </button>
                <button v-else class="button is-success"
                    @click="saveConfig">
                  <span class="icon">
                    <font-awesome-icon icon="save"></font-awesome-icon>
                  </span>
                  <span>Save</span>
                </button>
                <!-- <button class="button is-success has-badge-rounded has-badge-danger"
                    @click="saveConfig">
                  <span class="icon">
                    <font-awesome-icon icon="save"></font-awesome-icon>
                  </span>
                  <span>Save</span>
                </button> -->
              </div>
            </section>
            <hr style="margin: 20px 0px;">
            <!-- Form -->
            <section>
              <div class="field is-horizontal" style="padding-right: 3rem;">
                  <div class="field-label is-normal"><label class="label">Rule Name</label></div>
                  <div class="field-body">
                      <div class="field">
                        <input type="text" class="form-control control is-expanded"
                          id="nameInput" placeholder="Enter rule name"
                          v-model="selectedRule.name" @input="changeName(selectedRule.name)" :disabled="selectedRule.isDefault">
                      </div>
                  </div>
              </div>
              <div class="field is-horizontal" style="padding-right: 3rem;">
                  <div class="field-label is-normal"><label class="label">Type</label></div>
                  <div class="field-body">
                    <div class="field">
                      <div class="control is-expanded">
                        <div class="select is-fullwidth">
                          <select v-model="selectedTypeValue" @change="typeChange(selectedRule.type, $event)">
                            <option v-if="selectedRule.type === ``" value="" disabled selected>Select type</option>
                            <option v-for="type in typeList" :value="type.value" :key="type.value">
                              <span>{{ type.text }}</span>
                            </option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
              </div>
              <!-- model form -->
              <div v-if="selectedRule.type === 'model'" class="field is-horizontal" style="padding-right: 3rem;">
                <div class="field-label is-normal"><label class="label">Model</label></div>
                <div class="field-body">
                  <div class="field">
                    <div class="control is-expanded">
                      <div class="select is-fullwidth">
                        <select v-model="selectedModelIdValue" @change="modelIdChange(selectedRule.modelId, $event)">
                          <option v-if="!selectedRule.modelId" value="" disabled selected>Select model</option>
                          <option value="add-model">+ Add new model</option>
                          <option v-for="model in modelListForm" :value="model.value" :key="model.value">
                            {{ model.text }}
                          </option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
            <hr style="margin: 15px 0px 0px;">
            <section class="flex-section answer-section">


              <div v-if="selectedRule.modelId" class="toolbar" style="margin-top: 1.6rem;">
                <div class="toolbar-wrapper"></div>
                <div class="field is-grouped">
                  <div class="control">
                  </div>
                  <div class="control is-expanded has-text-right">
                    <div class="dropdown is-right is-hoverable has-text-left">
                      <div class="dropdown-trigger">
                        <button
                          class="button is-small"
                          aria-haspopup="true"
                          aria-controls="add-more-category"
                        >
                          <span class="icon">
                            <font-awesome-icon icon="plus-circle"></font-awesome-icon>
                          </span>
                          <span>Add Categories</span>
                        </button>
                      </div>
                      <div
                        class="dropdown-menu no-margin no-padding"
                        id="add-more-category"
                        role="menu"
                      >
                        <div class="dropdown-content">
                          <a class="dropdown-item" @click="isModalAddCategoryActive = true">
                            <em class="icon-add mr-1"></em>
                            <span>Add new category</span>
                          </a>
                          <a
                            class="dropdown-item"
                            v-for="(cat, index) in modelCategoryForm"
                            :key="'cat-' + index"
                            @click="addCategory(cat)"
                          >
                            <span>{{cat.text}}</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="selectedRule.type === 'regex'" class="toolbar" style="margin-top: 1.6rem;">
                  <!-- <div class="toolbar-wrapper"></div>
                  <div class="field is-grouped">
                      <div class="control">
                      </div>
                      <div class="control is-expanded has-text-right">
                            <div class="button is-small" @click="isModalRegexActive = true">
                              <span class="icon">
                                <font-awesome-icon icon="plus-circle"></font-awesome-icon>
                              </span>
                              <span>Add Regex</span>
                            </div>
                      </div>
                  </div> -->
                <div class="toolbar-wrapper"></div>
                <div class="field is-grouped">
                    <div class="control">
                    </div>
                    <div class="control is-expanded has-text-right">
                      <div class="dropdown is-right is-hoverable has-text-left">
                        <div class="dropdown-trigger">
                          <button
                            class="button is-small"
                            aria-haspopup="true"
                            aria-controls="add-regex"
                          >
                            <span class="icon">
                              <font-awesome-icon icon="plus-circle"></font-awesome-icon>
                            </span>
                            <span>Add</span>
                          </button>
                        </div>
                        <div
                          class="dropdown-menu no-margin no-padding"
                          id="add-regex"
                          role="menu"
                        >
                          <div class="dropdown-content">
                            <a
                              class="dropdown-item"
                              v-for="(op, index) in regexOptions"
                              :key="'op-' + index"
                              @click="selectRegexOption(op)"
                            >
                              <span>{{op.text}}</span>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
              <div v-if="selectedRule.type === 'rule_based_answer'" class="toolbar" style="margin-top: 1.6rem;">
                  <div class="toolbar-wrapper"></div>
                  <div class="field is-grouped">
                      <div class="control">
                      </div>
                      <div class="control is-expanded has-text-right">
                        <div class="dropdown is-right is-hoverable has-text-left">
                          <div class="dropdown-trigger">
                            <button
                              class="button is-small"
                              aria-haspopup="true"
                              aria-controls="add-more-answer"
                            >
                              <span class="icon">
                                <font-awesome-icon icon="plus-circle"></font-awesome-icon>
                              </span>
                              <span>Add Answer</span>
                            </button>
                          </div>
                          <div
                            class="dropdown-menu no-margin no-padding"
                            id="add-more-simple-answer"
                            role="menu"
                          >
                            <div class="dropdown-content">
                              <div v-for="(type, index) in answerTypesComputed" :key="'type-' + index">
                                <a
                                  v-if="type.show"
                                  class="dropdown-item"
                                  @click="addOutputAnswer(type)"
                                >
                                  <span>
                                    <font-awesome-icon :icon="type.icon"></font-awesome-icon>
                                  </span>
                                  <span>&nbsp;&nbsp;{{type.text}}</span>
                                </a>

                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                  </div>
              </div>

              <!-- List -->
              <div class="flex-section flex-bg answers-wrapper">
                <div class="no-answer" v-if="!selectedRule.type">
                  <span class="gray-text small-text">Please select type</span>
                </div>
                <div class="no-answer" v-if="selectedRule.type === 'model' && !selectedRule.modelId">
                  <span class="gray-text small-text">Please select model</span>
                </div>

                <!-- Model List -->
                <draggable
                  v-if="selectedRule.modelId"
                  :list="selectedRule.modelCategories"
                  :move="checkMove"
                  class="content"
                  @change="moveItem"
                  animation="150"
                  :options="{draggable: '.answer-type-wrap', handle: '.mock-user'}"
                >
                  <div
                    class="answer-type-wrap"
                    v-for="(cat, index) in selectedRule.modelCategories"
                    :key="cat.id+'-'+index"
                  >
                  <model-category
                      :dataCategory="cat.name"
                      :index="index"
                      :uid="cat.id+'-'+index"
                    ></model-category>
                  </div>
                  <div class="no-answer"
                      v-if="selectedRule && selectedRule.modelCategories
                      && selectedRule.modelCategories.length === 0">
                    <span class="gray-text small-text">No category added.</span>
                  </div>
                </draggable>

                 <!-- Regex List -->
                <draggable
                  v-if="selectedRule.type === 'regex'"
                  :list="selectedRule.regex"
                  class="content"
                  v-model="selectedRule.regex"
                  @change="moveItem"
                  :options="{draggable: '.answer-type-wrap', handle: '.mock-user'}"
                >
                  <div
                    class="answer-type-wrap"
                    v-for="(regex, index) in selectedRule.regex"
                    :key="selectedRule.id+'-ans-'+index"
                  >
                  <regex-list
                      v-if="!regex.isDefault"
                      :inputData="regex"
                      :index="index"
                      :uid="selectedRule.id+'-'+index"
                      @dirty="toggleRuleDirty(true)"
                      @deleted="removeRegex(index)"
                      @editRegex="editRegex"
                    ></regex-list>
                  </div>
                  <div
                    class="no-answer"
                    v-if="selectedRule && selectedRule.regex
                    && selectedRule.regex.length === 0"
                  >
                    <span class="gray-text small-text">No regex added.</span>
                  </div>
                </draggable>


                  <!-- Answer List -->
                <draggable
                  v-if="selectedRule.type === 'rule_based_answer'"
                  class="content"
                  :list="selectedAnswers"
                  @change="moveItemAnswer"
                  v-model="selectedAnswers"
                  :options="{draggable: '.answer-type-wrap', handle: '.mock-user'}"
                >
                  <div
                    class="answer-type-wrap"
                    v-for="(obj, index) in selectedAnswers"
                    :key="selectedRule.id+'-ans-'+index"
                  >
                    <any-text-answer
                      v-if="obj.type === 'send_any_message'"
                      :inputData.sync="obj"
                      :index="index"
                      :uid="selectedRule.id+'-'+index"
                      v-on:dirty="toggleAnswerDirty(true)"
                      v-on:deleted="removeAnswer(index)"
                    ></any-text-answer>
                    <!-- <change-rule
                      v-if="obj.type === 'change_rule'"
                      :inputData.sync="obj"
                      :rulesList="unfilteredRules"
                      :selectedRuleId="selectedRuleId"
                      :index="index"
                      v-on:dirty="toggleAnswerDirty(true)"
                      v-on:deleted="removeAnswer(index)"
                    ></change-rule> -->
                    <button-template
                      v-if="obj.type === 'button_template'"
                      :inputData.sync="obj"
                      :index="index"
                      :uid="selectedRule.id+'-'+index"
                      :dataInSameLevel="dataInSameLevel"
                      v-on:dirty="toggleAnswerDirty(true)"
                      v-on:deleted="removeAnswer(index)"
                    ></button-template>
                    <image-answer
                      v-if="obj.type === 'send_image'"
                      :inputData.sync="obj"
                      :index="index"
                      v-on:dirty="toggleAnswerDirty(true)"
                      v-on:deleted="removeAnswer(index)"
                    ></image-answer>
                    <video-answer
                      v-if="obj.type === 'send_video'"
                      :inputData.sync="obj"
                      :index="index"
                      v-on:dirty="toggleAnswerDirty(true)"
                      v-on:deleted="removeAnswer(index)"
                    ></video-answer>
                    <audio-answer
                      v-if="obj.type === 'send_audio'"
                      :inputData.sync="obj"
                      :index="index"
                      v-on:dirty="toggleAnswerDirty(true)"
                      v-on:deleted="removeAnswer(index)"
                    ></audio-answer>
                    <quick-reply
                      v-if="obj.type === 'quick_reply'"
                      :inputData.sync="obj"
                      :index="index"
                      :dataInSameLevel="dataInSameLevel"
                      v-on:dirty="toggleAnswerDirty(true)"
                      v-on:deleted="removeAnswer(index)"
                    ></quick-reply>


                    <div class="carousel-wrapper" v-if="obj.type === 'carousel_template'">
                        <!-- <perfect-scrollbar
                          :options="{
                            wheelSpeed: 2,
                            suppressScrollY: true,
                            useBothWheelAxes: true,
                            minScrollbarLength: 100
                          }"
                        > -->
                          <div class="carousel-content" v-for="(item,idx) in obj.items" :key="index+idx">
                            <button-template
                              :isCarousel="{ index: idx }"
                              :inputData.sync="item"
                              :index="index"
                              :uid="selectedRule.id+'-'+idx"
                              :dataInSameLevel="dataInSameLevel"
                              v-on:dirty="toggleAnswerDirty(true)"
                              v-on:deleted="removeAnswerCarousel(index,idx)"
                            ></button-template>
                          </div>

                          <div class="add-carousel-content" v-if="obj.items && obj.items.length < 10">
                            <div class="add-btn" @click="addCarousel(index)">
                              +
                            </div>
                          </div>
                        <!-- </perfect-scrollbar> -->
                    </div>

                     <div class="carousel-wrapper" v-if="obj.type === 'carousel_default_template'">
                          <div class="carousel-content" v-for="(item,idx) in obj.items" :key="index+idx">
                            <button-template
                              :isCarousel="{ index: idx }"
                              :inputData.sync="item"
                              :index="index"
                              :uid="selectedRule.id+'-'+idx"
                              :dataInSameLevel="dataInSameLevel"
                              v-on:dirty="toggleAnswerDirty(true)"
                              v-on:deleted="removeAnswerCarousel(index,idx)"
                            ></button-template>

                          </div>


                          <div class="add-carousel-content" v-if="obj.items && obj.items.length < 10">
                            <div class="add-btn" @click="addCarousel(index)">
                              +
                            </div>
                            <div class="delete-btn mt-2" @click="deleteDefaultCarousel(index)">
                              -
                            </div>
                          </div>
                    </div>


                    <!-- <div class="carousel-wrapper" v-if="obj.type === 'carousel_default_template'">

                        <perfect-scrollbar>
                          <div class="carousel-content" v-for="(item,idx) in obj.items" :key="index+idx">
                            <carousel-default-template
                              :isCarousel="{ index: idx }"
                              :inputData.sync="item"
                              :index="index"
                              :uid="selectedRule.id+'-'+idx"
                              v-on:dirty="toggleAnswerDirty(true)"
                              v-on:deleted="removeAnswerCarousel(index,idx)"
                            ></carousel-default-template>
                          </div>

                          <div class="add-carousel-content" v-if="obj.items && obj.items.length < 10">
                            <div class="add-btn" @click="addCarousel(index)">
                              +
                            </div>
                          </div>
                        </perfect-scrollbar>
                    </div> -->


                  </div>
                  <div
                    class="no-answer"
                    v-if="selectedRule
                    && selectedAnswers
                    && selectedAnswers.length === 0"
                  >
                    <span class="gray-text small-text">No answers added.</span>
                  </div>
                  <div
                    class="no-answer"
                    v-if="selectedRule
                      && selectedAnswers
                      && selectedAnswers.length > 0"
                  >
                    <hr />
                    <span class="gray-text small-text">End of conversation.</span>
                  </div>
                </draggable>


                <div v-if="selectedRule.type === 'next_to_state'">
                  <div class="answer-block columns is-flex answer-template">
                    <div class="is-flex">
                    </div>
                    <div class="column">
                      <div class="answer-block-wrapper">
                        <div class="box answer-box">
                          <label class="label is-small">
                            Next to state
                          </label>
                          <div class="field is-horizontal">
                            <div class="field-label is-small">
                              <label class="label">State</label>
                            </div>
                            <div class="field-body">
                              <div class="field">
                                <div class="control is-expanded">
                                  <input
                                    class="input is-small"
                                    type="text"
                                    v-model="selectedRule.stateId"
                                    placeholder="Enter state"
                                    required
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- <nav class="nav" role="navigation">
                  <ul class="nav__list">
                    <li>
                      <input id="group-1" type="checkbox" hidden="">
                      <label for="group-1"><span class="fa fa-angle-right"></span> First level</label>
                      <ul class="group-list">
                        <li><a href="#">1st level item</a></li>
                        <li>
                          <input id="sub-group-1" type="checkbox" hidden="">
                          <label for="sub-group-1"><span class="fa fa-angle-right"></span> Second level</label>
                          <ul class="sub-group-list">
                            <li><a href="#">2nd level nav item</a></li>
                            <li><a href="#">2nd level nav item</a></li>
                            <li><a href="#">2nd level nav item</a></li>
                            <li>
                              <input id="sub-sub-group-1" type="checkbox" hidden="">
                              <label for="sub-sub-group-1"><span class="fa fa-angle-right"></span> Third level</label>
                              <ul class="sub-sub-group-list">
                                <li><a href="#">3rd level nav item</a></li>
                                <li><a href="#">3rd level nav item</a></li>
                                <li><a href="#">3rd level nav item</a></li>
                              </ul>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </nav> -->


              </div>
            </section>
          </template>
        </div>
      </div>


      <!-- Modal for add regexs -->
      <div class="modal" :class="{'is-active': isModalRegexActive }">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Regex</p>
            <button class="delete" aria-label="close" @click="isModalRegexActive = false"></button>
          </header>
          <section class="modal-card-body">
            <div class="is-normal"><label class="label">Name</label></div>
            <div class="field-body mb-3">
                <div class="field">
                  <input type="text" class="form-control control is-expanded"
                          id="regexNameInput" placeholder="Enter regex name"
                          v-model="regexDetail.name">
                </div>
            </div>

            <div class="is-normal"><label class="label">Regex</label></div>
            <div class="field-body mb-3">
                <div class="field">
                  <input type="text" class="form-control control is-expanded"
                          id="regexInput" placeholder="Enter regex"
                          v-model="regexDetail.regex">
                </div>
            </div>

            <div class="is-normal"><label class="label">Flag</label></div>
<!--            <div class="form-check">-->
<!--              <input class="form-check-input" type="checkbox" id="globalCheck" v-model="regexDetail.flag.global">-->
<!--              <label class="form-check-label" for="globalCheck">-->
<!--                Global-->
<!--              </label>-->
<!--            </div>-->
<!--            <div class="form-check">-->
<!--              <input class="form-check-input" type="checkbox" id="multiCheck" v-model="regexDetail.flag.multiline">-->
<!--              <label class="form-check-label" for="multiCheck">-->
<!--                Multiline-->
<!--              </label>-->
<!--            </div>-->
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="insensitiveCheck" v-model="regexDetail.flag.insensitive">
              <label class="form-check-label" for="insensitiveCheck">
                Insensitive
              </label>
            </div>
          </section>

          <footer class="modal-card-foot justify-content-end">
            <div class="field is-grouped">
              <button class="button mr-2" @click="isModalRegexActive = false">Cancel</button>
              <button class="button is-info" @click="addRegex(regexDetail)" :disabled="!regexDetail.name || !regexDetail.regex">Add</button>
            </div>
          </footer>
        </div>
      </div>

      <!-- Modal for add a new model -->
      <div class="modal" :class="{'is-active': isModalAddModelActive }">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Add Model</p>
            <button class="delete" aria-label="close" @click="isModalAddModelActive = false"></button>
          </header>
          <section class="modal-card-body">
            <div class="is-normal"><label class="label">Model Name</label></div>
            <div class="field-body mb-3">
                <div class="field">
                  <input type="text" class="form-control control is-expanded"
                          id="regexNameInput" placeholder="Enter model name"
                          v-model="newModelDetail.name">
                </div>
            </div>

            <div class="is-normal"><label class="label">Model Description</label></div>
            <div class="field-body mb-3">
                <div class="field">
                  <input type="text" class="form-control control is-expanded"
                          id="regexInput" placeholder="Enter model description"
                          v-model="newModelDetail.description">
                </div>
            </div>
          </section>

          <footer class="modal-card-foot justify-content-end">
            <div class="field is-grouped">
              <button class="button mr-2" @click="clearNewModelDetail()">Cancel</button>
              <button class="button is-info" @click="addNewModel(newModelDetail)" :disabled="!newModelDetail.name">Add</button>
            </div>
          </footer>
        </div>
      </div>

      <!-- Modal for add a new category -->
      <div class="modal" :class="{'is-active': isModalAddCategoryActive }">
        <div class="modal-background"></div>
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">Add Category</p>
            <button class="delete" aria-label="close" @click="isModalAddCategoryActive = false"></button>
          </header>
          <section class="modal-card-body">
            <div class="is-normal"><label class="label">Category Name</label></div>
            <div class="field-body mb-3">
                <div class="field">
                  <input type="text" class="form-control control is-expanded"
                          id="regexNameInput" placeholder="Enter model name"
                          v-model="newCategoryDetail.name">
                </div>
            </div>
          </section>

          <footer class="modal-card-foot justify-content-end">
            <div class="field is-grouped">
              <button class="button mr-2" @click="clearNewCategoryDetail()">Cancel</button>
              <button class="button is-info" @click="addNewCategory(newCategoryDetail)" :disabled="!newCategoryDetail.name">Add</button>
            </div>
          </footer>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import draggable from 'vuedraggable';
import virtualList from 'vue-virtual-scroll-list';

// import PerfectScrollbar from 'vue2-perfect-scrollbar';
// import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css';
// import { debounce } from 'underscore';
// import { v4 as uid } from 'uuid';
import uid from 'uniqid';
import anyText from '../components/Answers/AnyTextAnswer.vue';
// import changeRule from '../components/Answers/ChangeRule.vue';
import buttonTemplate from '../components/Answers/ButtonTemplate.vue';
import imageAnswer from '../components/Answers/ImageAnswer.vue';
import videoAnswer from '../components/Answers/VideoAnswer.vue';
import audioAnswer from '../components/Answers/AudioAnswer.vue';
import quickReply from '../components/Answers/QuickReplyAnswer.vue';
import modelCategory from '../components/Configfile/ModelCategory.vue';
import regexList from '../components/Configfile/RegexList.vue';

export default {
  name: 'config',
  components: {
    draggable,
    'virtual-list': virtualList,
    'any-text-answer': anyText,
    // 'change-rule': changeRule,
    'button-template': buttonTemplate,
    'image-answer': imageAnswer,
    'video-answer': videoAnswer,
    'audio-answer': audioAnswer,
    'quick-reply': quickReply,
    'model-category': modelCategory,
    'regex-list': regexList,
    // 'perfect-scrollbar': PerfectScrollbar,
  },
  data() {
    return {
      answerTypes: [
        {
          name: 'text',
          icon: 'comment-dots',
          text: 'Text answer',
          show: true,
          answer: {
            type: 'send_any_message',
            text: [''],
          },
        },
        {
          name: 'button_template',
          icon: 'list-alt',
          text: 'Button template',
          show: true,
          answer: {
            type: 'button_template',
            thumbnailImageUrl: '',
            title: '',
            text: '',
            buttons: [],
          },
        },
        {
          name: 'carousel_template',
          icon: 'comment-alt',
          text: 'Carousel template',
          show: true,
          answer: {
            type: 'carousel_template',
            thumbnailImageUrl: '',
            title: '',
            text: '',
            buttons: [],
          },
        },
        {
          name: 'carousel_default_template',
          icon: 'comment-alt',
          text: 'Carousel Default template',
          show: false,
          answer: {
            type: 'carousel_default_template',
            thumbnailImageUrl: '',
            title: '',
            text: '',
            buttons: [],
          },
        },
        {
          name: 'image',
          icon: 'image',
          text: 'Image answer',
          show: true,
          answer: {
            type: 'send_image',
            url: '',
          },
        },
        {
          name: 'video',
          icon: 'video',
          text: 'Video answer',
          show: true,
          answer: {
            type: 'send_video',
            url: '',
          },
        },
        {
          name: 'audio',
          icon: 'music',
          text: 'Audio answer',
          show: true,
          answer: {
            type: 'send_audio',
            url: '',
            duration: 0,
          },
        },
        // {
        //   name: 'change_rule',
        //   icon: 'arrow-right',
        //   text: 'Redirect rule',
        //   answer: {
        //     type: 'change_rule',
        //     ruleId: '',
        //   },
        // },
        {
          name: 'quick_reply',
          icon: 'comments',
          text: 'Quick reply',
          show: true,
          answer: {
            type: 'quick_reply',
            text: '',
            buttons: [],
          },
        },
      ],
      carouselTemplate: [],
      selectedRuleId: '',
      selectedAnswerSetIndex: 0,
      rulesList: [],
      answerDirty: false,
      selectedConfigFileId: null,
      selectedConfigFileData: null,
      dataList: [],
      typeList: [
        { value: 'model', text: 'Model' },
        { value: 'regex', text: 'Regex' },
        { value: 'rule_based_answer', text: 'Answer' },
        { value: 'next_to_state', text: 'Next to state' },
        { value: 'end', text: 'End' },
      ],
      selectedRule: null,
      isModalRegexActive: false,
      regexDetail: {
        name: null,
        regex: null,
        flag: {
          global: false,
          multiline: false,
          insensitive: false,
        },
        isDefault: false,
      },
      AllData: [], // all data from api
      convertResult: [],
      isLoading: true,
      ruleDirty: false,
      selectedTypeValue: null,
      selectedModelIdValue: null,
      selectedConfigFileIdValue: null,

      // modal for add a new model
      isModalAddModelActive: false,
      newModelDetail: {
        name: '',
        description: ''
      },
      // modal for add a new category
      isModalAddCategoryActive: false,
      newCategoryDetail: {
        name: '',
      }
    };
  },
  mounted() {
    this.loadModelList();
    this.getAllConfigFile().then((list) => {
      this.isLoading = false;
      if (list && list.data.length > 0) {
        this.selectedConfigFileId = list.data[0].id;
        this.selectedConfigFileIdValue = list.data[0].id;
        this.getConfigFile(this.selectedConfigFileId)
          .then(async (responseConfig) => {
            this.selectedConfigFileData = responseConfig.data;
            const config = { ...responseConfig.data.config };
            await this.convertDataFromApiFirst(config, 0);
            this.dataList = this.convertDataConfigFile(config, 0);
            this.toggleRule(this.dataList[0].id);
          });
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    if (this.ruleDirty) {
      this.$buefy.dialog.confirm({
        title: 'Discard changes',
        message: 'You have unsaved changes, are you going to discard these changes?',
        cancelText: 'Cancel',
        confirmText: 'Discard',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          next();
        },
        onCancel: () => {},
      });
    } else {
      next();
    }
  },
  methods: {
    ...mapActions({
      loadModelList: 'model/loadModelList',
      loadModelCategory: 'nlpconfig/loadModelCategory',
      createConfigFile: 'nlpconfig/createConfigFile',
      getAllConfigFile: 'nlpconfig/getAllConfigFile',
      getConfigFile: 'nlpconfig/getConfigFile',
      updateConfigFile: 'nlpconfig/updateConfigFile',
      deleteConfigFile: 'nlpconfig/deleteConfigFile',
      createModel: 'model/createModel',
      createCategory: 'model/createCategory',
    }),
    checkMove(evt) {
      return (!evt.draggedContext.element.isDefault);
    },
    moveItem() {
      this.toggleRuleDirty(true);
      const listEntry = this.convertToJSON([...this.dataList], 0, null);
      this.convertResult = [];
      this.dataList = this.convertDataConfigFile({ ...listEntry[0] }, 0);
      setTimeout(() => {
        this.toggleRule(this.selectedRuleId);
      }, 500);
    },
    moveItemAnswer() {
      this.toggleRuleDirty(true);
    },
    editRegex(newValue) {
      const data = this.dataList.find((rule) => rule.id === newValue.id);
      data.name = newValue.name;
    },
    changeName(name) {
      this.toggleRuleDirty(true);
      // change model category name in own parent
      const data = this.dataList.find((rule) => rule.id === this.selectedRule.parentId);
      if (data) {
        if (data.type === 'model') {
          // eslint-disable-next-line guard-for-in
          for (const obj of data.modelCategories) {
            if (obj.id === this.selectedRule.id) {
              obj.name = name;
            }
          }
        }
        if (data.type === 'regex') {
          // eslint-disable-next-line guard-for-in
          for (const obj of data.regex) {
            if (obj.id === this.selectedRule.id) {
              obj.name = name;
              obj.categoryId = name;

              // for regex -> change categoryId
              this.selectedRule.categoryId = name;

              // for change payload in default carousel
              this.changePayloadInDefaultCarousel(name);
            }
          }
        }
      }
    },
    getIcon(rule) {
      if (rule) {
        // if DEFAULT
        // if (rule.id.includes('default_')) {
        if (rule.isDefault) {
          if (!rule.type) {
            return 'fas fa-pen-square text-danger';
          }
          if (rule.type === 'model' && rule.modelCategories && rule.modelCategories.length === 0) {
            return 'fas fa-pen-square text-danger';
          }
          if (rule.type === 'regex' && rule.regex && rule.regex.length === 0) {
            return 'fas fa-pen-square text-danger';
          }
          if (rule.type === 'rule_based_answer' && rule.answers[0] && rule.answers[0].length === 0) {
            return 'fas fa-pen-square text-danger';
          }
          if (rule.type === 'next_to_state' && !rule.stateId) {
            return 'fas fa-pen-square text-danger';
          }
          return 'fas fa-pen-square';
        }


        if (rule.type === 'model') {
          if (rule.modelCategories && rule.modelCategories.length === 0) {
            return 'fas fa-robot text-danger';
          }
          return 'fas fa-robot';
        }

        if (rule.type === 'regex') {
          if (rule.regex && rule.regex.length === 0) {
            return 'fas fa-code text-danger';
          }
          return 'fas fa-code';
        }

        if (rule.type === 'rule_based_answer') {
          if (rule.answers[0] && rule.answers[0].length === 0) {
            return 'fas fa-comment text-danger';
          }
          return 'fas fa-comment';
        }

        if (rule.type === 'next_to_state') {
          if (!rule.stateId) {
            return 'fas fa-share text-danger';
          }
          return 'fas fa-share';
        }
      }
      return 'fas fa-exclamation-circle text-danger';

      // if (rule && rule.id.includes('default_')) {
      //   if (!rule.type) {
      //     return 'fas fa-pen-square text-danger';
      //   }
      //   return 'fas fa-pen-square';
      // }
      // if (rule && rule.type) {
      //   if (rule.type === 'model') {
      //     return 'fas fa-robot';
      //   } if (rule.type === 'regex') {
      //     return 'fas fa-code';
      //   } if (rule.type === 'next_to_state') {
      //     return 'fas fa-share';
      //   }
      //   return 'fas fa-comment';
      // }
      // return 'fas fa-exclamation-circle text-danger';
    },
    getTextColor (rule) {
      if (!rule.type) {
        return 'text-danger';
      }
      if (rule.type === 'model' && rule.modelCategories && rule.modelCategories.length === 0) {
        return 'text-danger';
      }
      if (rule.type === 'regex' && rule.regex && rule.regex.length === 0) {
        return 'text-danger';
      }
      if (rule.type === 'rule_based_answer' && rule.answers[0] && rule.answers[0].length === 0) {
        return 'text-danger';
      }
      if (rule.type === 'next_to_state' && !rule.stateId) {
        return 'text-danger';
      }
      if (rule.type === 'end') {
        return '';
      }
      return '';
    },
    reloadConfigFile(oldConfigFileId, event) {
      const newConfigFileId = event.target.value;
      if (this.ruleDirty) {
        this.$buefy.dialog.confirm({
          title: 'Discard changes',
          message: 'You have unsaved changes, are you going to discard these changes?',
          cancelText: 'Cancel',
          confirmText: 'Discard',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => {
            this.convertResult = [];
            this.selectedConfigFileId = newConfigFileId;
            this.selectedConfigFileIdValue = newConfigFileId;
            this.getConfigFile(newConfigFileId)
              .then((responseConfig) => {
                this.selectedConfigFileData = responseConfig.data;
                const config = { ...responseConfig.data.config };
                this.dataList = this.convertDataConfigFile(config, 0);
                this.toggleRuleDirty(false);
                this.toggleRule(this.dataList[0].id);
                // this.toggleRule(this.dataList[0].path);
              });
          },
          onCancel: () => {
            this.selectedConfigFileIdValue = oldConfigFileId;
          },
        });
      } else {
        this.convertResult = [];
        this.selectedConfigFileId = newConfigFileId;
        this.selectedConfigFileIdValue = newConfigFileId;
        this.getConfigFile(newConfigFileId)
          .then((responseConfig) => {
            this.selectedConfigFileData = responseConfig.data;
            const config = { ...responseConfig.data.config };
            this.dataList = this.convertDataConfigFile(config, 0);
            this.toggleRuleDirty(false);
            this.toggleRule(this.dataList[0].id);
            // this.toggleRule(this.dataList[0].path);
          });
      }
    },
    createNewConfig() {
      this.$buefy.dialog.prompt({
        message: 'Enter new config name.',
        inputAttrs: {
          maxlength: 25,
        },
        onConfirm: (configName) => {
          this.convertResult = [];
          const configData = {
            name: configName,
            config: {
              id: uid(),
              level: 0,
              parentId: null,
              originId: null,
              isDefault: false,
              name: 'Untitled',
              type: '',
              modelId: '',
              stateId: '',
              predictedResult: {},
              regex: {},
              answers: [[]],
            },
          };
          this.createConfigFile(configData).then((res) => {
            const { id } = res;
            this.getAllConfigFile().then((list) => {
              if (list && list.data.length > 0) {
                list.data.forEach((item) => {
                  if (item.id === id) {
                    this.selectedConfigFileId = item.id;
                    this.selectedConfigFileIdValue = item.id;
                    this.getConfigFile(this.selectedConfigFileId)
                      .then((responseConfig) => {
                        this.selectedConfigFileData = responseConfig.data;
                        const config = { ...responseConfig.data.config };
                        this.dataList = this.convertDataConfigFile(config, 0);
                        this.toggleRule(this.dataList[0].id);
                      });
                  }
                });
              }
            });
            this.$buefy.toast.open({
              type: 'is-success',
              message: 'New Config is added',
              position: 'is-bottom',
            });
          })
            .catch(() => {
              this.$buefy.toast.open({
                type: 'is-danger',
                message: 'Unexpected error occurred.',
                position: 'is-bottom',
              });
            });
        },
      });
    },
    addCategory(category) {
      const newCategory = {
        id: category.id,
        categoryId: category.categoryId,
        name: category.isDefault ? 'Default' : category.value,
        isDefault: category.isDefault,
      };
      const data = this.dataList.find((rule) => rule.path === this.selectedRuleId);

      // const defaultValue = data.modelCategories.find((el) => el.id.includes('default_'));

      const defaultValue = data.modelCategories.find((el) => el.isDefault);
      if (defaultValue) {
        data.modelCategories.splice(data.modelCategories.length - 1, 0, newCategory);
      } else {
        data.modelCategories.push(newCategory);
      }
      // Add new sub-rule
      this.addSubRule(data, newCategory);
    },
    selectRegexOption(option) {
      if (option.value === 'regex') {
        this.isModalRegexActive = true;
      } else if (option.value === 'default') {
        const newRegex = {
          // id: `${'default'}_${this.selectedRule.path}`,
          id: uid(),
          categoryId: 'default',
          name: 'Default',
          isDefault: true,
          // regex: null,
          // flag: {
          //   global: false,
          //   multiline: false,
          //   insensitive: false,
          // },
        };

        const data = this.dataList.find((rule) => rule.path === this.selectedRuleId);
        data.regex.push(newRegex);
        // Add new sub-rule
        this.addSubRule(data, newRegex);
      }
    },
    addRegex(regexDetail) {
      this.isModalRegexActive = false;
      // Add regex to their own parent ( update dataList )
      const newRegex = { ...regexDetail };
      newRegex.id = uid();
      newRegex.categoryId = newRegex.name;
      // regexDetail.id = uid();
      const data = this.dataList.find((rule) => rule.path === this.selectedRuleId);
      // data.regex.push(newRegex);
      // เรียง
      // const defaultValue = data.regex.find((el) => el.id.includes('default_'));
      const defaultValue = data.regex.find((el) => el.isDefault);
      if (defaultValue) {
        data.regex.splice(data.regex.length - 1, 0, newRegex);
      } else {
        data.regex.push(newRegex);
      }


      // Add new sub-rule
      this.addSubRule(data, newRegex);
      // Clear regexDetail
      this.regexDetail = {
        name: null,
        regex: null,
        flag: {
          global: false,
          multiline: false,
          insensitive: false,
        },
      };
    },
    addSubRule(parentData, newSubRule) {
      // add new sub-rule
      // const id = uid();
      let originId = null;
      if (parentData.level === 0) {
        originId = parentData.id;
      } else {
        originId = parentData.originId;
      }

      const newSubRuleObj = {
        id: newSubRule.id,
        isDefault: newSubRule.isDefault,
        originId,
        level: parentData.level + 1,
        parentId: parentData.id,
        name: newSubRule.name,
        type: '',
        modelId: '',
        categoryId: newSubRule.categoryId || '',
        stateId: '',
        modelCategories: [],
        regex: [],
        answers: [[]],
      };
      this.dataList.push(newSubRuleObj);

      // add item in default_carousel (when have default)
      this.addItemInDefaultCarousel(newSubRuleObj);


      this.$refs.ruleList.forceRender();
      this.toggleRuleDirty(true);
    },
    addItemInDefaultCarousel (newSubRuleObj) {
      const rulebaseItem = this.dataList.filter((data) => data.level === newSubRuleObj.level && data.type === 'rule_based_answer');

      if (rulebaseItem && rulebaseItem.length > 0) {
        for (const item of rulebaseItem) {
          if (item.answers && item.answers[0].length > 0) {
            for (const i of item.answers[0]) {
              if (i.type === 'carousel_default_template') {
                // for push item in order e.g. isDefaultCarousel | others
                const isDefaultItems = i.items.filter((el) => el.isDefaultCarousel);
                i.items.splice(isDefaultItems.length, 0, {
                  isDefaultCarousel: true,
                  // parentId: newSubRuleObj.id,
                  type: 'button_template',
                  thumbnailImageUrl: '',
                  title: newSubRuleObj.name,
                  text: '',
                  buttons: [{
                    label: 'ดูข้อมูล',
                    type: 'category_button',
                    payload: newSubRuleObj.categoryId,
                  }],
                });
              }
            }
          }
        }
      }
    },
    changePayloadInDefaultCarousel (name) {
      const levelData = this.dataList.filter((data) => data.level === this.selectedRule.level && data.parentId === this.selectedRule.parentId && data.id !== this.selectedRule.id);
      const dataForFindIndex = this.dataList.filter((data) => data.level === this.selectedRule.level && data.parentId === this.selectedRule.parentId);
      const indexForChangePayload = dataForFindIndex.findIndex((data) => data.id === this.selectedRule.id);

      if (levelData && levelData.length > 0) {
        for (const item of levelData) {
          if (item.answers && item.answers[0].length > 0) {
            for (const i of item.answers[0]) {
              if (i.type === 'carousel_default_template') {
                if (i.items && i.items[indexForChangePayload] && i.items[indexForChangePayload].buttons[0] && i.items[indexForChangePayload].buttons[0].payload) {
                  i.items[indexForChangePayload].buttons[0].payload = name;
                  break;
                }
              }
            }
          }
        }
      }
    },
    removeCategory(index) {
      this.selectedRule.modelCategories.splice(index, 1);
    },
    removeRegex(index) {
      this.selectedRule.regex.splice(index, 1);
    },
    toggleRule(rulePath) {
      this.selectedRuleId = rulePath;
      if (rulePath) {
        // this.selectedRuleId = rulePath;
        const result = this.dataList.find((data) => data.path === rulePath || data.id === rulePath);
        if (result) {
          this.selectedRule = result;
          this.selectedTypeValue = result.type;
          this.selectedModelIdValue = result.modelId;
          if (result.modelId) {
            this.loadModelCategory(result.modelId);
          }

          if (result.type === 'rule_based_answer') {
            // this.sortCarouselDefault();
          }
        } else {
          this.selectedRuleId = null;
          this.selectedRule = null;
        }
      }
    },
    sortCarouselDefault () {
      const sortOrder = [];
      for (const data of this.dataInSameLevel) {
        sortOrder.push(data.name);
      }

      // check answers in selected rule > sort by order of model list
      if (this.selectedRule.answers && this.selectedRule.answers[0] && this.selectedRule.answers[0].length > 0) {
        const itemList = this.selectedRule.answers[0].filter((ans) => ans.type === 'carousel_default_template');
        if (itemList && itemList[0] && itemList[0].items && itemList[0].items.length > 0) {
          itemList[0].items.sort((a, b) => sortOrder.indexOf(a.title) - sortOrder.indexOf(b.title));
        }
      }
    },
    typeChange(oldType, event) {
      this.toggleRuleDirty(true);
      const newType = event.target.value;
      // Check if the rule to be changed have sub-rules.
      if (oldType === 'end') {
        this.selectedRule.stateId = '';
      }
      if (oldType && (this.selectedRule.modelCategories.length || this.selectedRule.regex.length || this.selectedRule.answers[0].length || this.selectedRule.stateId.length)) {
        this.$buefy.dialog.confirm({
          title: 'Changing rule type',
          message: 'Are you sure to change rule type?',
          cancelText: 'Cancel',
          confirmText: 'Change',
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () => {
            this.selectedRule.type = newType;
            const { id, level } = this.selectedRule;
            const selectedId = level > 0 ? id.split('_')[level - 1] : id.split('_')[level];

            if (oldType === 'model') {
              // for (const item of this.selectedRule.modelCategories) {
              //   console.log('item', item);
              //   this.deleteChildById(item.id);
              // }
              // remove children by id
              this.dataList = this.deleteChildById(selectedId);
              this.selectedRule.modelId = '';
              this.selectedRule.modelCategories = [];
              this.selectedModelIdValue = '';
            }
            if (oldType === 'regex') {
              // remove children by id
              this.dataList = this.deleteChildById(selectedId);
              this.selectedRule.regex = [];
            }
            if (oldType === 'rule_based_answer') {
              this.selectedRule.answers = [[]];
            }
            if (newType === 'next_to_state') {
              this.selectedRule.stateId = '';
            }
            // if (newType !== 'model') {
            //   this.selectedRule.modelId = '';
            //   this.selectedRule.modelCategories = [];
            //   this.selectedModelIdValue = '';
            // }
            // if (newType !== 'regex') {
            //   this.selectedRule.regex = [];
            // }
            // if (newType !== 'rule_based_answer') {
            //   this.selectedRule.answers = [[]];
            // }
            // Delete sub-rules by the level of the rule changed
            // this.deleteSubRule(this.selectedRule.level);
          },
          onCancel: () => {
            this.selectedTypeValue = oldType;
          },
        });
      } else {
        this.selectedRule.type = newType;
        if (newType !== 'model') {
          this.selectedRule.modelId = '';
          this.selectedRule.modelCategories = [];
          this.selectedModelIdValue = '';
        }
        if (newType !== 'regex') {
          this.selectedRule.regex = [];
        }
        if (newType !== 'rule_based_answer') {
          this.selectedRule.answers = [[]];
        }
        if (newType !== 'next_to_state') {
          this.selectedRule.stateId = '';
        }
        if (newType !== 'end') {
          this.selectedRule.stateId = '';
        }
      }
    },
    deleteChildById(id) {
      // this.dataList = this.dataList.filter((data) => data.id !== id);
      const result = [];
      for (const data of this.dataList) {
        if (data.level > this.selectedRule.level && data.path) {
          // find path === id > remove
          const filtered = data.path.split('_').indexOf(id);
          if (filtered < 0) result.push(data);
        } else {
          result.push(data);
        }
      }
      return result;
    },
    // insertToSpecificIndex (array, index, data) {
    //   return [
    //     ...array.slice(0, index),
    //     data,
    //     ...array.slice(index)
    //   ];
    // },
    modelIdChange(oldModelId, event) {
      const newModelId = event.target.value;

      if (newModelId !== 'add-model') {
        // Check if the rule to be changed have sub-rules.
        if (oldModelId && this.selectedRule.modelCategories.length) {
          this.$buefy.dialog.confirm({
            title: 'Changing model',
            message: 'Are you sure to change model ?',
            cancelText: 'Cancel',
            confirmText: 'Change',
            type: 'is-danger',
            hasIcon: true,
            onConfirm: async () => {
              this.toggleRuleDirty(true);
              await this.loadModelCategory(newModelId);
              this.selectedModelIdValue = newModelId;
              this.selectedRule.modelId = newModelId;
              this.selectedRule.modelCategories = [];
              // Delete sub-rules by the level of the rule changed
              // this.deleteSubRule(this.selectedRule.level);
              const { id, level } = this.selectedRule;
              const selectedId = level > 0 ? id.split('_')[level - 1] : id.split('_')[level];
              this.dataList = this.deleteChildById(selectedId);
            },
            onCancel: () => {
              this.selectedModelIdValue = oldModelId;
            },
          });
        } else {
          this.loadModelCategory(newModelId);
          this.selectedModelIdValue = newModelId;
          this.selectedRule.modelId = newModelId;
          this.selectedRule.modelCategories = [];
        }
      } else {
        this.isModalAddModelActive = true;
        this.selectedModelIdValue = oldModelId;
      }
    },
    deleteSubRule(ruleChangeLevel) {
      if (this.dataList) {
        // Sort rule by level
        const levelData = [];
        for (let item = 0; item < this.dataList.length; item += 1) {
          const { level } = this.dataList[item];
          if (levelData[level]) {
            levelData[level].push(this.dataList[item]);
          } else {
            levelData[level] = [this.dataList[item]];
          }
        }

        const parentList = [];
        parentList.push(this.selectedRuleId);
        for (let lv = 0; lv < levelData.length; lv += 1) {
          if (lv > ruleChangeLevel) {
            const data = levelData[lv];
            // eslint-disable-next-line array-callback-return
            parentList.some((parent) => {
              for (let item = 0; item < data.length; item += 1) {
                if (data[item].parentId === parent || `${data[item].originId}_${data[item].parentId}` === parent) {
                  parentList.push(data[item].id);
                  data.splice(item, 1);
                  item -= 1;
                }
                // if (data[item].parent === parent) {
                //   parentList.push(data[item].id);
                //   data.splice(item, 1);
                //   item -= 1;
                // }
              }
            });
          }
        }
        const sortedList = [];
        for (let j = 0; j < levelData.length; j += 1) {
          for (let k = 0; k < levelData[j].length; k += 1) {
            if (j === 0) {
              levelData[j][k].path = levelData[j][k].id;
              sortedList.push(levelData[j][k]);
            } else {
            // Find the parent in sortedList
              let targetIndex = -1;
              let parentObj = {};
              for (let l = 0; l < sortedList.length; l += 1) {
                if (sortedList[l].id === levelData[j][k].parentId) {
                  targetIndex = l;
                  parentObj = sortedList[l];
                  break;
                }
              }
              if (targetIndex > -1) {
                levelData[j][k].path = `${parentObj.path}_${levelData[j][k].id}`;
                // sortedList.push(levelData[j][k]);
                if (targetIndex === sortedList.length - 1) {
                // Last mean push new one.
                  sortedList.push(levelData[j][k]);
                } else {
                  sortedList.splice(targetIndex + 1, 0, levelData[j][k]);
                }
              } else {
                sortedList.push(levelData[j][k]);
              }
            }
          }
        }
        this.dataList = [...sortedList];
      }
    },
    sortListByLevel(dataSort) {
      const levelData = [...dataSort];
      const sortedList = [];
      for (let j = 0; j < levelData.length; j += 1) {
        for (let k = 0; k < levelData[j].length; k += 1) {
          if (j === 0) {
            levelData[j][k].path = levelData[j][k].id;
            sortedList.push(levelData[j][k]);
          } else {
            // Find the parent in sortedList
            let targetIndex = -1;
            let parentObj = {};
            for (let l = 0; l < sortedList.length; l += 1) {
              if (sortedList[l].id === levelData[j][k].parentId) {
                targetIndex = l;
                parentObj = sortedList[l];
                break;
              }
            }
            if (targetIndex > -1) {
              levelData[j][k].path = `${parentObj.path}_${levelData[j][k].id}`;
              if (targetIndex === sortedList.length - 1) {
                // Last mean push new one.
                sortedList.push(levelData[j][k]);
              } else {
                sortedList.splice(targetIndex + 1, 0, levelData[j][k]);
              }
            } else {
              sortedList.push(levelData[j][k]);
            }
          }
        }
      }
      this.dataList = [...sortedList];
    },
    removeSubRule(rule) {
      this.$buefy.dialog.confirm({
        title: 'Removing rule',
        message: 'Are you sure to remove this rule?',
        cancelText: 'Cancel',
        confirmText: 'Remove',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.toggleRuleDirty(true);
          this.removeSubRuleFN(rule.id, rule.level);

          // remove data in default_carousel
          this.removeItemInDefaultCarousel(rule);
          this.removeFromDataList(rule);
        },
      });
    },
    removeItemInDefaultCarousel(rule) {
      const ruleBasedAnswerList = this.dataList.filter((item) => item.level === rule.level && item.type === 'rule_based_answer');
      if (ruleBasedAnswerList && ruleBasedAnswerList.length > 0) {
        for (const ans of ruleBasedAnswerList) {
          if (ans.answers && ans.answers[0] && ans.answers[0].length > 0) {
            for (const obj of ans.answers[0]) {
              if (obj.type === 'carousel_default_template' && obj.items && obj.items.length > 0) {
                obj.items.splice(obj.items.findIndex((i) => i.parentId === rule.id), 1);
              }
            }
          }
        }
      }

      // const dafaultCarousel = this.dataList.filter((item) => item.id.includes('default_'));

      // if (dafaultCarousel && dafaultCarousel.length > 0) {
      //   for (const item of dafaultCarousel) {
      //     for (const [idx, ans] of item.answers[0].entries()) {
      //       if (ans.type === 'carousel_default_template') {
      //         for (const [index, value] of ans.items.entries()) {
      //           if (value.parent === rule.id) {
      //             ans.items.splice(index, 1);
      //           }
      //         }

      //         // check for remove object
      //         if (ans.items && ans.items.length === 0) {
      //           item.answers[0].splice(idx, 1);
      //         }
      //       }
      //     }
      //   }
      // }
    },
    removeSubRuleFN(ruleId, deleteLV) {
      if (this.dataList) {
        // Sort rule by level
        const levelData = [];
        for (let item = 0; item < this.dataList.length; item += 1) {
          const { level } = this.dataList[item];
          if (levelData[level]) {
            levelData[level].push(this.dataList[item]);
          } else {
            levelData[level] = [this.dataList[item]];
          }
        }

        const parentList = [];
        parentList.push(ruleId);
        for (let lv = 0; lv < levelData.length; lv += 1) {
          if (lv >= deleteLV) {
            const data = levelData[lv];
            // eslint-disable-next-line array-callback-return
            parentList.some((parent) => {
              for (let item = 0; item < data.length; item += 1) {
                if (data[item].id === parent || data[item].parentId === parent) {
                  parentList.push(data[item].id);
                  data.splice(item, 1);
                  item -= 1;
                }
              }
            });
          }
        }

        // Sort by 'adding rules' and 'Default' is always the last one
        for (let j = 0; j < levelData.length; j += 1) {
          const levelArr = levelData[j];
          if (j > 0) {
            levelArr.sort((a, b) => {
              // if (b.id.includes('default')) {
              if (b.isDefault) {
                return 1;
              }
              return -1;
            });
          }
        }
        const sortedList = [];
        for (let j = 0; j < levelData.length; j += 1) {
          for (let k = 0; k < levelData[j].length; k += 1) {
            if (j === 0) {
              levelData[j][k].path = levelData[j][k].id;
              sortedList.push(levelData[j][k]);
            } else {
            // Find the parent in sortedList
              let targetIndex = -1;
              let parentObj = {};
              for (let l = 0; l < sortedList.length; l += 1) {
                if (sortedList[l].id === levelData[j][k].parentId) {
                  targetIndex = l;
                  parentObj = sortedList[l];
                  break;
                }
              }
              if (targetIndex > -1) {
                levelData[j][k].path = `${parentObj.path}_${levelData[j][k].id}`;
                // sortedList.push(levelData[j][k]);
                if (targetIndex === sortedList.length - 1) {
                // Last mean push new one.
                  sortedList.push(levelData[j][k]);
                } else {
                  sortedList.splice(targetIndex + 1, 0, levelData[j][k]);
                }
              } else {
                sortedList.push(levelData[j][k]);
              }
            }
          }
        }
        this.dataList = [...sortedList];
        this.toggleRule(this.dataList[0].id);
      }
    },
    removeFromDataList(rule) {
      const result = this.dataList.find((item) => item.id === rule.parentId);

      // check type
      if (result && result.type === 'model' && result.modelCategories.length) {
        const removeIndex = result.modelCategories.findIndex((category) => category.id === rule.id);
        result.modelCategories.splice(removeIndex, 1);
        // check if parent does not have child > reset modelId
        if (!result.modelCategories.length) {
          result.type = '';
          result.modelId = '';
          this.selectedModelIdValue = '';
        }
      }

      if (result && result.type === 'regex' && result.regex.length) {
        const removeIndex = result.regex.findIndex((reg) => reg.id === rule.id);
        result.regex.splice(removeIndex, 1);
        if (!result.regex.length) {
          result.type = '';
        }
      }

      // if (result && result.modelCategories.length) {
      //   const removePosition = result.modelCategories.findIndex((category) => category === itemForRemove);
      //   result.modelCategories.splice(removePosition, 1);
      //   // check if parent does not have child > reset modelId
      //   if (!result.modelCategories.length) {
      //     result.modelId = '';
      //     this.selectedModelIdValue = '';
      //   }
      // } else if (result && result.regex.length) {
      //   const removePosition = result.regex.findIndex((category) => category.name === itemForRemove);
      //   result.regex.splice(removePosition, 1);
      // }
    },
    saveConfig() {
      this.AllData = [];
      const data = [...this.dataList];
      const listEntry = this.convertToJSON(data, 0, null);
      const configId = this.selectedConfigFileId;
      if (configId && Object.keys(listEntry[0]).length) {
        const configData = {
          name: this.selectedConfigFileData.name,
          config: { ...listEntry[0] },
        };
        this.updateConfigFile({ configId, configData }).then((responseUpdate) => {
          this.toggleRuleDirty(false);
          const configUpdateId = responseUpdate.id;
          this.convertResult = [];
          this.getConfigFile(configUpdateId)
            .then(async (responseConfig) => {
              this.selectedConfigFileData = responseConfig.data;
              const config = { ...responseConfig.data.config };
              await this.convertDataFromApiFirst(config, 0);
              this.dataList = this.convertDataConfigFile(config, 0);
              this.toggleRule(this.dataList[0].id);
              // this.toggleRule(this.dataList[0].id);
              if (this.dataList[0].type === 'end') {
                Vue.delete(this.dataList[0], 'stateId');
              }
            });
          this.$buefy.toast.open({
            type: 'is-success',
            message: 'Config updated',
            position: 'is-bottom',
          });
        })
          .catch(() => {
            this.$buefy.toast.open({
              type: 'is-danger',
              message: 'Unexpected error occurred.',
              position: 'is-bottom',
            });
          });
      }
    },
    convertToJSON(data, level, parent) {
      const resultList = [];
      const levelDataList = data.filter(
        (entry) => entry.level === level && entry.parentId === parent,
      );
      for (const item of levelDataList) {
        if (item.type === 'model' && item.modelCategories.length > 0) {
          // Prepare prediction result
          const predictionResult = {};
          // Recursive function
          const childEntryList = this.convertToJSON(data, level + 1, item.id);
          // convert to map
          // map by categoryId (old ver. -> map by name)
          const childEntryMap = {};
          for (const child of childEntryList) {
            childEntryMap[child.id] = child;
          }
          for (const cat of item.modelCategories) {
            const child = childEntryMap[cat.id] || {};
            predictionResult[cat.id] = child;
          }

          const result = {
            id: item.id,
            isDefault: item.isDefault || false,
            level: item.level,
            parentId: item.parentId || null,
            originId: item.originId || null,
            name: item.name,
            type: 'model',
            modelId: item.modelId,
            categoryId: item.categoryId || '',
            predictedResult: predictionResult,
            // regex: {},
            // answers: [[]],
          };
          resultList.push(result);
        } else if (item.type === 'regex') {
          // Prepare prediction result
          const predictionResult = {};
          const childEntryList = this.convertToJSON(data, level + 1, item.id);

          // convert to map
          const childEntryMap = {};
          for (const child of childEntryList) {
            childEntryMap[child.name] = child;
          }
          const regexCategoryObj = {};
          for (const reg of item.regex) {
            const child = childEntryMap[reg.name] || {};
            predictionResult[reg.name] = child;
            regexCategoryObj[reg.name] = {
              name: reg.name,
              regex: reg.regex,
              flag: reg.flag,
            };
          }
          const result = {
            id: item.id,
            isDefault: item.isDefault || false,
            level: item.level,
            parentId: item.parentId || null,
            originId: item.originId || null,
            name: item.name,
            type: 'regex',
            // modelId: '',
            categoryId: item.categoryId || '',
            predictedResult: predictionResult,
            regex: regexCategoryObj,
            // answers: [[]],
          };
          resultList.push(result);
        } else if (item.type === 'rule_based_answer') {
          const result = {
            id: item.id,
            level: item.level,
            parentId: item.parentId || null,
            originId: item.originId || null,
            name: item.name,
            type: 'rule_based_answer',
            categoryId: item.categoryId || '',
            // modelId: '',
            // predictedResult: {},
            // regex: {},
            answers: item.answers,
          };
          resultList.push(result);
        } else if (item.type === 'end') {
          const result = {
            id: item.id,
            isDefault: item.isDefault || false,
            level: item.level,
            parentId: item.parentId,
            originId: item.originId,
            name: item.name,
            type: item.type || '',
            // modelId: '',
            categoryId: item.categoryId || '',
            // predictedResult: {},
            // regex: {},
            // answers: [[]],
          };
          resultList.push(result);
        } else {
          const result = {
            id: item.id,
            isDefault: item.isDefault || false,
            level: item.level,
            parentId: item.parentId,
            originId: item.originId,
            name: item.name,
            type: item.type || '',
            // modelId: '',
            categoryId: item.categoryId || '',
            stateId: item.stateId || '',
            // predictedResult: {},
            // regex: {},
            // answers: [[]],
          };
          resultList.push(result);
        }
      }
      return resultList;
    },
    convertDataFromApiFirst(object, level) {
      const key = 'name';

      if (Object.keys(object).length) {
        if (key in object) {
          const categoryMap = [];
          let answersMap = [];
          const regexMap = [];
          if (object.type === 'model') {
            for (const value of Object.values(object.predictedResult)) {
              categoryMap.push({
                id: value.id,
                isDefault: value.isDefault,
                categoryId: value.categoryId || '',
                name: value.name,
              });
            }
          } else if (object.type === 'regex') {
            for (const [keyName, value] of Object.entries(object.predictedResult)) {
              regexMap.push({
                id: value.id,
                name: keyName,
                categoryId: value.categoryId || '',
                regex: object.regex[keyName].regex,
                flag: object.regex[keyName].flag,
                isDefault: value.isDefault,
              });
            }
          } else if (object.type === 'rule_based_answer') {
            answersMap = object.answers;
          }

          const result = {
            id: object.id,
            isDefault: object.isDefault,
            level,
            parentId: object.parentId || null,
            originId: object.originId || null,
            name: object.name,
            type: object.type,
            stateId: object.stateId || '',
            modelId: object.modelId || '',
            categoryId: object.categoryId || '',
            modelCategories: categoryMap,
            regex: regexMap || [],
            answers: answersMap.length > 0 ? answersMap : [[]],
          };
          this.AllData.push(result);
        } else {
          // eslint-disable-next-line no-param-reassign
          level -= 1;
        }
      }

      // eslint-disable-next-line guard-for-in
      for (const property in object) {
        if (object[property]) {
          if (
            typeof object[property] === 'object'
          && property !== 'regex'
          && property !== 'answers'
          ) {
            // Recursive
            this.convertDataFromApiFirst(object[property], level + 1);
          }
        }
      }
    },
    convertDataConfigFile(object, level) {
      const key = 'name';

      if (Object.keys(object).length) {
        if (key in object) {
          const categoryMap = [];
          let answersMap = [];
          const regexMap = [];
          if (object.type === 'model') {
            // categoryMap = Object.keys(object.predictedResult);
            for (const value of Object.values(object.predictedResult)) {
              categoryMap.push({
                id: value.id,
                isDefault: value.isDefault,
                categoryId: value.categoryId || '',
                name: value.name,
                order: value.order
                // name: keyName,
              });
            }
          } else if (object.type === 'regex') {
            // regexMap = Object.values(object.regex);
            for (const [keyName, value] of Object.entries(object.predictedResult)) {
              regexMap.push({
                id: value.id,
                name: keyName,
                categoryId: value.categoryId || '',
                regex: object.regex[keyName].regex,
                flag: object.regex[keyName].flag,
                isDefault: value.isDefault,
              });
            }
          } else if (object.type === 'rule_based_answer') {
            answersMap = object.answers;
            for (const answerSet of answersMap) {
              for (const answer of answerSet) {
                const { type } = answer;
                if (type === 'button_template') {
                  const { buttons } = answer;
                  for (const btn of buttons) {
                    const newPayload = this.convertPayload(btn);
                    if (newPayload) {
                      btn.payload = newPayload;
                    }
                  }
                } else if (type === 'carousel_template' || type === 'carousel_default_template') {
                  for (const carousel of answer.items) {
                    for (const btn of carousel.buttons) {
                      const newPayload = this.convertPayload(btn);
                      if (newPayload) {
                        btn.payload = newPayload;
                      }
                    }
                  }
                }
              }
            }
          }

          const result = {
            id: object.id,
            isDefault: object.isDefault,
            level,
            parentId: object.parentId || null,
            originId: object.originId || null,
            name: object.name,
            type: object.type,
            stateId: object.stateId || '',
            modelId: object.modelId || '',
            categoryId: object.categoryId || '',
            modelCategories: categoryMap,
            regex: regexMap || [],
            answers: answersMap.length > 0 ? answersMap : [[]],
          };
          this.convertResult.push(result);
        } else {
          // eslint-disable-next-line no-param-reassign
          level -= 1;
        }
      }

      // eslint-disable-next-line guard-for-in
      for (const property in object) {
        if (object[property]) {
          if (
            typeof object[property] === 'object'
          && property !== 'regex'
          && property !== 'answers'
          ) {
            // Recursive
            this.convertDataConfigFile(object[property], level + 1);
          }
        }
      }
      return this.convertResult;
    },
    convertPayload (button) {
      const payloadId = button.payload;
      let result;
      for (const data of this.AllData) {
        if (data.id === payloadId || data.categoryId === payloadId) {
          result = data;
        }
      }
      return result && result.categoryId ? result.categoryId : null;
    },
    deleteConfigFileById(configId) {
      this.$buefy.dialog.confirm({
        title: 'Removing config',
        message: 'Are you sure to remove this config ?',
        cancelText: 'Cancel',
        confirmText: 'Remove',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.deleteConfigFile(configId)
            .then(() => {
              this.convertResult = [];
              this.selectedRuleId = '';
              this.selectedRule = null;
              this.getAllConfigFile().then((list) => {
                if (list && list.data.length > 0) {
                  this.selectedConfigFileId = list.data[0].id;
                  this.selectedConfigFileIdValue = list.data[0].id;
                  this.getConfigFile(this.selectedConfigFileId)
                    .then((responseConfig) => {
                      this.selectedConfigFileData = responseConfig.data;
                      const config = { ...responseConfig.data.config };
                      this.dataList = this.convertDataConfigFile(config, 0);
                      this.toggleRule(this.dataList[0].id);
                      // this.toggleRule(this.dataList[0].id);
                    });
                } else {
                  this.dataList = [];
                  this.selectedConfigFileId = null;
                  this.selectedConfigFileIdValue = null;
                }
              });
              this.$buefy.toast.open({
                type: 'is-success',
                message: 'Config file removed.',
                position: 'is-bottom',
              });
            })
            .catch(() => {
              this.$buefy.toast.open({
                type: 'is-danger',
                message: 'Unexpected error occurred.',
                position: 'is-bottom',
              });
            });
        },
      });
    },
    toggleRuleDirty(state) {
      this.ruleDirty = state;
    },
    removeAnswerCarousel (parentIndex, index) {
      this.toggleRule(this.selectedRuleId);
      this.toggleRuleDirty(true);

      if (this.selectedAnswers && this.selectedAnswers.length > 0) {
        if (this.selectedAnswers[parentIndex] && this.selectedAnswers[parentIndex].items && this.selectedAnswers[parentIndex].items.length > 0) {
          this.selectedAnswers[parentIndex].items.splice(index, 1);
        }
        if (!this.selectedAnswers.length) {
          this.selectedRule.type = '';
        }


        // check for remove object
        if (this.selectedAnswers[parentIndex] && this.selectedAnswers[parentIndex].items && this.selectedAnswers[parentIndex].items.length === 0) {
          this.selectedAnswers.splice(parentIndex, 1);
        }
      }
    },
    removeAnswer(index) {
      if (this.selectedAnswers) {
        this.selectedAnswers.splice(index, 1);
        if (!this.selectedAnswers.length) {
          this.selectedRule.type = '';
        }
        this.toggleRuleDirty(true);
        this.toggleRule(this.selectedRuleId);
      }
    },
    getLevelClass(rule) {
      return `level-${rule.level}`;
    },
    styleObject(rule) {
      return {
        'border-left': `${rule.level}0px solid #ddd`,
      };
    },
    addCarousel (parentIndex) {
      this.toggleRuleDirty(true);
      const answerCarousel = {
        type: 'button_template',
        thumbnailImageUrl: '',
        title: '',
        text: '',
        buttons: [],
      };

      const ans = JSON.parse(JSON.stringify(answerCarousel));

      if (this.selectedAnswers && this.selectedAnswers.length > 0) {
        if (this.selectedAnswers[parentIndex] && this.selectedAnswers[parentIndex].items) {
          this.selectedAnswers[parentIndex].items.push(ans);
        }
      }
    },
    deleteDefaultCarousel (parentIndex) {
      this.$buefy.dialog.confirm({
        title: 'Removing Default Carousel',
        message: 'Are you sure to remove default carousel?',
        cancelText: 'Cancel',
        confirmText: 'Remove',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => {
          this.toggleRuleDirty(true);
          if (this.selectedAnswers && this.selectedAnswers.length > 0) {
            this.selectedAnswers.splice(parentIndex, 1);
          }
        },
        onCancel: () => {},
      });
    },
    addOutputAnswer(type) {
      if (!this.selectedAnswers) {
        this.selectRule.answers[this.selectedAnswerSetIndex] = [];
      }
      const ans = JSON.parse(JSON.stringify(type.answer));

      // for carousel
      if (type.name === 'carousel_template') {
        this.selectedAnswers.push({
          type: 'carousel_template',
          items: [{
            type: 'button_template',
            thumbnailImageUrl: '',
            title: '',
            text: '',
            buttons: [],
          }],
        });
      } else if (type.name === 'carousel_default_template') {
        // check the existing items at the same level and id isn't itself for add in carousel_default_template (!data.id.includes('default_'))
        const defaultList = this.dataList.filter((data) => data.level === this.selectedRule.level && data.id !== this.selectedRule.id && data.parentId === this.selectedRule.parentId);
        const items = [];
        if (defaultList && defaultList.length > 0) {
          for (const item of defaultList) {
            items.push({
              isDefaultCarousel: true,
              // parentId: item.id,
              type: 'button_template',
              thumbnailImageUrl: '',
              title: item.name,
              text: '',
              buttons: [{
                label: 'ดูข้อมูล',
                type: 'category_button',
                payload: item.categoryId,
              }],
            });
          }

          this.selectedAnswers.push({
            type: 'carousel_default_template',
            items
          });
        }
      } else {
        this.selectedAnswers.push(ans);
      }

      this.$forceUpdate();
    },
    moveAnswer(obj) {
      let pos = obj.index;
      if (obj.direction === 'down') {
        pos += 1;
      } else {
        pos -= 1;
      }
      this.toggleAnswerDirty(true);
      const moving = this.selectedAnswers.splice(obj.index, 1)[0];
      this.selectedAnswers.splice(pos, 0, moving);
    },
    toggleAnswerDirty(state) {
      this.toggleRuleDirty(state);
      this.answerDirty = state;
    },
    // Can add a new model or a new category on this page (NLP Config)
    async addNewModel() {
      const modelData = this.newModelDetail;
      try {
        await this.createModel({ modelData });
        await this.loadModelList();
        this.$buefy.toast.open({
          type: 'is-success',
          message: 'Model added.',
          position: 'is-bottom',
        });
        this.clearNewModelDetail();
      } catch (e) {
        if (e.response.status === 409) {
          this.$buefy.toast.open({
            type: 'is-warning',
            message: `Cannot add duplicate model name ${modelData.name} in to model list.`,
            position: 'is-bottom',
            duration: 3500,
          });
        } else {
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'Unexpected error occurred.',
            position: 'is-bottom',
            duration: 3500,
          });
        }
      }
    },
    async addNewCategory() {
      const modelId = this.selectedModelIdValue;
      const categoryData = this.newCategoryDetail;
      try {
        await this.createCategory({ modelId, categoryData });
        this.loadModelCategory(modelId);
        this.$buefy.toast.open({
          type: 'is-success',
          message: 'New category added.',
          position: 'is-bottom',
        });
        this.clearNewCategoryDetail();
      } catch (e) {
        if (e.response.status === 409) {
          this.$buefy.toast.open({
            type: 'is-warning',
            message: `Cannot add duplicate category name ${categoryData.name} in to category list.`,
            position: 'is-bottom',
            duration: 3500,
          });
        } else {
          this.$buefy.toast.open({
            type: 'is-danger',
            message: 'Unexpected error occurred.',
            position: 'is-bottom',
            duration: 3500,
          });
        }
      }
    },
    clearNewModelDetail() {
      this.isModalAddModelActive = false;
      this.newModelDetail = {
        name: '',
        description: ''
      };
    },
    clearNewCategoryDetail() {
      this.isModalAddCategoryActive = false;
      this.newCategoryDetail = {
        name: '',
      };
    },
  },
  computed: {
    ...mapGetters({
      modelList: 'model/modelList',
      categoryList: 'nlpconfig/categoryList',
      allConfigFile: 'nlpconfig/allConfigFile',
      configFileData: 'nlpconfig/configFileData',
    }),
    sortModelCategories () {
      // TODO: fix order undefined
      if (this.selectedRule.modelCategories && this.selectedRule.modelCategories.length > 0) {
        const ordered = this.selectedRule.modelCategories;
        return ordered.sort((a, b) => {
          if (a.order < b.order) {
            return -1;
          }
          if (b.order > a.order) {
            return 1;
          }
          return 0;
        });
      }
      return this.selectedRule.modelCategories;
    },
    modelListForm() {
      const result = [];
      // if (this.selectedRule.type === 'model') {
      if (this.modelList && this.modelList.length > 0) {
        for (let item = 0; item < this.modelList.length; item += 1) {
          result.push({
            value: this.modelList[item].id,
            text: this.modelList[item].name,
          });
        }
        return result;
      }
      // }
      return [];
    },
    modelCategoryForm() {
      const result = [];
      let selected = null;
      if (this.selectedRule.modelId) {
        if (this.categoryList) {
          const categories = [...this.categoryList.categories];
          for (const cat of categories) {
            if (cat.name !== 'no-intention') {
              selected = this.selectedRule.modelCategories.find((el) => el.categoryId === cat.id);

              // if this category has not been selected > push this category to dropdown list (modelCategoryForm)
              // if (!selected) {
              //   result.push({
              //     id: `${cat.id}_${this.selectedRule.path}`,
              //     value: cat.name,
              //     text: cat.name,
              //   });
              // }

              // v2. add categoryId
              if (!selected) {
                result.push({
                  id: `${cat.id}_${this.selectedRule.path}`,
                  isDefault: false,
                  categoryId: cat.id,
                  value: cat.name,
                  text: cat.name,
                });
              }
            }
          }

          // const found = this.selectedRule.modelCategories.find((el) => el.id === `${'default'}_${this.selectedRule.path}`);
          const found = this.selectedRule.modelCategories.find((el) => el.isDefault);
          if (!found) {
            // result.push({
            //   id: `${'default'}_${this.selectedRule.path}`,
            //   // id: 'default',
            //   categoryId: 'default',
            //   value: 'default',
            //   text: 'default',
            // });

            // v.2 change id to uid() and add isDefault field
            result.push({
              id: uid(),
              isDefault: true,
              // id: 'default',
              categoryId: 'default',
              value: 'default',
              text: 'Default',
            });
          }

          return result;
        }
      }
      return [];
    },
    regexOptions() {
      const result = [{ value: 'regex', text: 'Regex' }];
      if (this.selectedRule.type === 'regex') {
        // const found = this.selectedRule.regex.find((el) => el.id === `${'default'}_${this.selectedRule.path}`);
        const found = this.selectedRule.regex.find((el) => el.isDefault);
        if (!found) {
          result.push({
            value: 'default',
            text: 'Default',
          });
        }
        return result;
      }
      return result;
    },
    unfilteredRules() {
      if (this.rulesList) {
        // Sort rule by level
        const levelData = [];
        const sortedList = [];
        for (let i = 0; i < this.rulesList.length; i += 1) {
          const { level } = this.rulesList[i];
          if (levelData[level]) {
            levelData[level].push(this.rulesList[i]);
          } else {
            levelData[level] = [this.rulesList[i]];
          }
        }
        // Sort each by text : Level 0 sort by asc, Others sort by desc
        for (let j = 0; j < levelData.length; j += 1) {
          const levelArr = levelData[j];
          if (j === 0) {
            levelArr.sort((a, b) => {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }
              return 0;
            });
          } else {
            levelArr.sort((a, b) => {
              if (b.name < a.name) {
                return -1;
              }
              if (b.name > a.name) {
                return 1;
              }
              return 0;
            });
          }
        }

        // Outer level is pushed first
        for (let j = 0; j < levelData.length; j += 1) {
          for (let k = 0; k < levelData[j].length; k += 1) {
            if (j === 0) { // มี TEST 1 / TEST 2
              levelData[j][k].path = levelData[j][k].id;
              sortedList.push(levelData[j][k]);
            } else {
              // Find the parent in sortedList
              let targetIndex = -1;
              let parentObj = {};
              for (let l = 0; l < sortedList.length; l += 1) {
                if (sortedList[l].id === levelData[j][k].parentId) {
                  targetIndex = l;
                  parentObj = sortedList[l];
                  break;
                }
              }
              if (targetIndex > -1) {
                levelData[j][k].path = `${parentObj.path}_${levelData[j][k].id}`;
                if (targetIndex === sortedList.length - 1) {
                  // Last mean push new one.
                  sortedList.push(levelData[j][k]);
                } else {
                  sortedList.splice(targetIndex + 1, 0, levelData[j][k]);
                }
              } else {
                sortedList.push(levelData[j][k]);
              }
            }
          }
        }
        return sortedList;
      }
      return [];
    },
    rulesOriginMap() {
      const result = {};
      if (this.rulesList) {
        for (let i = 0; i < this.rulesList.length; i += 1) {
          const rule = this.rulesList[i];
          if (result[rule.originId]) {
            result[rule.originId].push(rule);
          } else {
            result[rule.originId] = [rule];
          }
        }
        Object.keys(result).forEach((k) => {
          if (result[k] && result[k].length > 1) {
            result[k] = result[k].sort((a, b) => a.level - b.level);
          }
        });
      }
      return result;
    },
    filteredRules() {
      const searchInput = this.searchInput.toLowerCase();
      if (searchInput.length > 0 && this.rulesList) {
        // filter by text and keyword
        const rawFilter = this.rulesList.filter((data) => {
          const longKeywords = data.keywords.join('|').toLowerCase();
          const target = data.name.toLowerCase();
          return target.indexOf(searchInput) > -1 || longKeywords.indexOf(searchInput) > -1;
        });
        const rawFilteredPathList = rawFilter.map((obj) => obj.path);
        // get map of path
        const filteredIdMap = new Map();
        rawFilteredPathList.forEach((path) => {
          if (path.indexOf('|') > -1) {
            const splitted = path.split('|');
            splitted.forEach((subPath) => {
              filteredIdMap.set(subPath, {});
            });
          } else {
            filteredIdMap.set(path, {});
          }
        });
        // get all possible child of filtered
        for (let i = 0; i < rawFilter.length; i += 1) {
          const obj = rawFilter[i];
          const { origin } = obj;
          if (this.rulesOriginMap && this.rulesOriginMap[origin] && this.rulesOriginMap[origin].length > 1) {
            const list = this.rulesOriginMap[origin];
            for (let j = 0; j < list.length; j += 1) {
              if (list[j].level > obj.level) {
                filteredIdMap.set(list[j].id, {});
              }
            }
          }
        }
        // then search from id
        const filteredIdList = [...filteredIdMap.keys()];
        let filteredRules = [];
        filteredRules = this.rulesList.filter((rule) => filteredIdList.indexOf(rule.id) > -1);
        // Sort rule by level
        const levelData = [];
        const sortedList = [];
        for (let i = 0; i < filteredRules.length; i += 1) {
          const { level } = filteredRules[i];
          if (levelData[level]) {
            levelData[level].push(filteredRules[i]);
          } else {
            levelData[level] = [filteredRules[i]];
          }
        }
        // Sort each by text : Level 0 sort by asc, Others sort by desc
        for (let j = 0; j < levelData.length; j += 1) {
          const levelArr = levelData[j];
          if (j === 0) {
            levelArr.sort((a, b) => {
              if (a.name < b.name) {
                return -1;
              }
              if (a.name > b.name) {
                return 1;
              }
              return 0;
            });
          } else {
            levelArr.sort((a, b) => {
              if (b.name < a.name) {
                return -1;
              }
              if (b.name > a.name) {
                return 1;
              }
              return 0;
            });
          }
        }
        // Outer level is pushed first
        for (let j = 0; j < levelData.length; j += 1) {
          for (let k = 0; k < levelData[j].length; k += 1) {
            if (j === 0) {
              levelData[j][k].path = levelData[j][k].id;
              sortedList.push(levelData[j][k]);
            } else {
              // Find the parent in sortedList
              let targetIndex = -1;
              let parentObj = {};
              for (let l = 0; l < sortedList.length; l += 1) {
                if (sortedList[l].id === levelData[j][k].parentId) {
                  targetIndex = parseInt(l, 10);
                  parentObj = sortedList[l];
                  break;
                }
              }
              if (targetIndex > -1) {
                levelData[j][k].path = `${parentObj.path}_${levelData[j][k].id}`;
                if (targetIndex === sortedList.length - 1) {
                  // Last mean push new one.
                  sortedList.push(levelData[j][k]);
                } else {
                  sortedList.splice(targetIndex + 1, 0, levelData[j][k]);
                }
              } else {
                sortedList.push(levelData[j][k]);
              }
            }
          }
        }
        return sortedList;
      }
      return this.unfilteredRules;
    },
    // selectedRule: {
    //   get() {
    //     if (this.selectedRuleId) {
    //       const result = this.rulesList.find((rule) => rule.id === this.selectedRuleId);
    //       if (result) {
    //         return result;
    //       }
    //     }
    //     return null;
    //   },
    //   set(data) {
    //     if (this.selectedRuleId) {
    //       const index = this.rulesList.map((rule) => rule.id).indexOf(this.selectedRuleId);
    //       if (index > -1) {
    //         this.rulesList[index] = data;
    //       }
    //     }
    //   },
    // },
    selectedAnswers: {
      get() {
        if (this.selectedRule) {
          return this.selectedRule.answers[this.selectedAnswerSetIndex];
        }
        return false;
      },
      set(val) {
        if (this.selectedRule) {
          const index = this.dataList.map((rule) => rule.id).indexOf(this.selectedRule);
          if (index > -1) {
            Vue.set(this.dataList[index].answers, this.selectedAnswerSetIndex, val);
            this.answerDirty = true;
          }
        }
      },
    },
    sortedRuleList() {
      if (this.dataList) {
        // Sort rule by level
        const levelData = [];
        const sortedList = [];
        for (let i = 0; i < this.dataList.length; i += 1) {
          const { level } = this.dataList[i];
          if (levelData[level]) {
            levelData[level].push(this.dataList[i]);
          } else {
            levelData[level] = [this.dataList[i]];
          }
        }

        // Sort by 'adding rules' and 'Default' is always the last one
        for (let j = 0; j < levelData.length; j += 1) {
          const levelArr = levelData[j];
          if (j > 0) {
            levelArr.sort((a, b) => {
              // if (b.id.includes('default')) {
              if (b.isDefault) {
                return 1;
              }
              return -1;
            });
          }
        }

        // Outer level is pushed first
        for (let level = 0; level < levelData.length; level += 1) {
          for (let item = 0; item < levelData[level].length; item += 1) {
            if (level === 0) {
              levelData[level][item].path = levelData[level][item].id;
              sortedList.push(levelData[level][item]);
            } else {
              // level > 0
              // Find the parent in sortedList
              let targetIndex = -1;
              let parentObj = {};
              for (let index = 0; index < sortedList.length; index += 1) {
                // หาว่า data อันไหนคือ parent ของตัวเอง โดยการเช็ค id ของ parent กับ parent ของ ตัวเอง ถ้าตรงกัน แปลว่า obj นี้ คือ parent
                if (sortedList[index].id === levelData[level][item].parentId) {
                  targetIndex = index;
                  parentObj = sortedList[index];
                  break;
                }
              }

              if (targetIndex > -1) {
                levelData[level][item].path = `${parentObj.path}_${levelData[level][item].id}`;
                if (targetIndex === sortedList.length - 1) { // when taget = 0 === sortedList.length - 1
                  // Last mean push new one.
                  sortedList.push(levelData[level][item]);
                } else {
                  sortedList.splice(targetIndex + 1, 0, levelData[level][item]);
                }
              } else {
                sortedList.push(levelData[level][item]);
              }
            }
          }
        }
        return sortedList;
      }
      return [];
    },
    answerTypesComputed() {
      // Set to TRUE when id: default_ , type: rule_based_answer and Haven't chosen the type of carousel_default_template yet
      if (this.selectedRule && this.selectedRule.level > 0 && this.selectedRule.isDefault) {
        const itemCarouselDefault = this.selectedRule.answers[0].filter((ans) => ans.type === 'carousel_default_template');
        // Haven't chosen the type of carousel_default_template yet
        if (itemCarouselDefault && itemCarouselDefault.length === 0) {
          // check the existing items at the same level and id isn't itself for show menu carousel_default_template (deleted !data.id.includes('default_'))
          const existingItems = this.dataList.filter((data) => data.level === this.selectedRule.level && data.id !== this.selectedRule.id);
          if (existingItems && existingItems.length > 0) {
            for (const ans of this.answerTypes) {
              if (ans.name === 'carousel_default_template') {
                ans.show = true;
              }
            }
            return this.answerTypes;
          }
        }
      }
      for (const ans of this.answerTypes) {
        if (ans.name === 'carousel_default_template') {
          ans.show = false;
        }
      }
      return this.answerTypes;
    },
    dataInSameLevel () {
      if (this.selectedRule) {
        const data = this.dataList.filter((d) => d.level === this.selectedRule.level && d.id !== this.selectedRule.id);
        if (data && data.length > 0) {
          return data;
        }
        return [];
      }
      return [];
    }
  },
};
</script>
<style lang="scss" scoped>
  // TODO: som
  .card {
    margin-bottom: 0 !important;
  }
  // .card-header {
  //   border-top: 0;
  //   border-bottom: 1px solid rgba(0,0,0,.125);
  // }
  .card-header:not([class*=bg-]):not([class*=alpha-]) {
    background-color: none !important;
    padding-top: none !important;
    padding-bottom: none !important;
  }
  .rule-based {
    text-align: left;
    .title-label {
      font-size: 1.25rem;
      line-height: 2.5rem;
    }
    .column-content {
      padding: 0.6rem;
    }
    .flex-section {
      display: flex;
      flex: 1 1 auto;
      overflow: auto;
      &.flex-bg {
        background-color: #f9f9f9;
        box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
      }
    }
    .answer-section {
      // margin-top: 15px;
      flex-direction: column;
    }
    .list-wrapper {
      display: flex;
      flex-direction: column;
      overflow-x: hidden;
      width: 100%;
    }
    .table {
      border: none;
      td {
        border-width: 1px;
        border-color: #ddd;
        cursor: pointer;
      }
    }
    .custom-table-head {
      border: 1px solid #ddd;
      background-color: #f6f6f6;
      .seperator {
        color: #ddd;
        margin-right: 10px;
      }
    }
    .selected-rule {
      color: #fff;
      font-weight: bold;
      background-color: #0d94e4;
      border-color: #0d94e4 !important;
      /*background-image: linear-gradient(to right,#32a8ee, #0d94e4);*/
      .level-icon {
        color: #fff !important;
      }
    }
    .rule-level {
      line-height: 2em;
      min-height: 42px;
      background-color: #fff;
      border-bottom: 1px solid #ddd;
      .icon {
        font-weight: bold;
        vertical-align: middle;
      }
    }
    .rule-inner {
      min-height: 42px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 .5rem;
    }
    .level-1 {
      border-left: 20px solid #ddd;
      .level-icon {
        margin-right: 5px;
        color: #ff3d3a;
      }
    }
    .level-2 {
      border-left: 40px solid #ddd;
      .level-icon {
        color: #ff823a;
      }
    }
    .level-3 {
      border-left: 60px solid #ddd;
      .level-icon {
        color: #46ab36;
      }
    }
    .level-4 {
      border-left: 80px solid #ddd;
      .level-icon {
        color: #677bff;
      }
    }
    .toolbar {
      display: flex;
      flex: 0 0 auto;
      flex-direction: row;
      .toolbar-wrapper {
        display: flex;
        flex: 1 1 auto;
        // overflow-x: scroll;
        .title {
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          font-size: 1.25rem;
          line-height: 2.25rem;
        }
      }
      .button {
        margin-left: 10px;
      }
    }
    .answers-wrapper {
      flex-direction: column;
      padding: 20px;
      border-top: 1px solid #ededed;
      .no-answer {
        text-align: center;
        padding: 10px;
      }
      .answer-type-wrap {
        margin-bottom: 15px;

        .carousel-wrapper {
          // display: -webkit-box;
          display: flex;
          flex-direction: row;
          height: 100%;
          min-height: 280px;
          max-height: 360px;
          // max-height: 355px;

          /* width: 400px; */
          overflow-x: scroll;
          overflow-y: hidden;

          .ps {
            display: flex;
            height: 100%;
          }

          .carousel-content {
            // height: 360px;
            // min-height: 280px;
            // min-height: 270px;
            // max-height: 355px;
          }

          .carousel-content:not(:last-child) {
            margin-right: 20px;
          }

          .add-carousel-content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            .add-btn {
              height: 30px;
              line-height: 30px;
              width: 30px;
              font-size: 2em;
              font-weight: bold;
              border-radius: 50%;
              background-color: #0D94E4;
              color: white;
              text-align: center;
              cursor: pointer;
            }
            .delete-btn {
              height: 30px;
              line-height: 30px;
              width: 30px;
              font-size: 2em;
              font-weight: bold;
              border-radius: 50%;
              background-color: #f00b0b;
              color: white;
              text-align: center;
              cursor: pointer;
            }
          }
        }
      }
    }
    .add-wrapper {
      background-color: #f9f9f9;
      padding: 10px;
      border-top: 1px solid #eee;
      .dropdown {
        .button {
          border-radius: 3px;
        }
      }
      .button {
        border-radius: 3px;
        margin-right: 5px;
      }
    }
    .gray-text {
      color: #aaa;
    }
    .small-text {
      font-size: 0.75rem;
    }
    .bottom-field {
      position: relative;
      .control {
        border-top: 2px solid #eee;
      }
    }
    .rule-set-id {
      position: absolute;
      top: 6px;
      right: 0;
      color: #ddd;
      font-size: 12px;
    }
  }

  .dropdown-item, .dropdown .dropdown-menu .has-link a {
    display: inline-block  !important;
  }

  .dropdown-item-disabled {
    color: #aaa;
    cursor: not-allowed;
    opacity: 0.5;
    text-decoration: none;
  }

  .dropdown-content:not(ul) {
    width: 100%;
    padding-top: 0.5rem !important;
  }
</style>
